import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

export type ExpandedAnsicht = 'full' | 'half' | 'third';
export const ExpandedStateStore = signalStore(
  withState({
    expanded: false,
    split50: false,
  }),
  withComputed(({ expanded, split50 }) => ({
    ansicht: computed<ExpandedAnsicht>(() =>
      expanded() ? 'full'
      : split50() ? 'half'
      : 'third'
    ),
  })),
  withMethods(store => ({
    getCurrentStateFor(mode: 'expanded' | 'split50') {
      switch (mode) {
        case 'expanded':
          return store.expanded();
        case 'split50':
          return store.split50();
        default:
          throw new Error(`Stand von ${mode} wird nicht verwaltet`);
      }
    },
  })),
  withMethods(store => ({
    toggle(mode: 'expanded' | 'split50', explicitValue?: boolean) {
      const current = store.getCurrentStateFor(mode);
      if (current == explicitValue) return;

      patchState(store, { [mode]: !current });
      return;
    },

    explicit(explicitMode: ExpandedAnsicht) {
      if (explicitMode == store.ansicht()) return;

      switch (explicitMode) {
        case 'full': {
          patchState(store, { expanded: true });
          break;
        }
        case 'half': {
          patchState(store, { expanded: false, split50: true });
          break;
        }
        case 'third':
        case null: {
          patchState(store, { expanded: false, split50: false });
          break;
        }
      }
    },
  }))
);
